import { A, Base, Div, Span } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { Choice } from '../../components/choice'
import rates, { IRates, RateGroup, formatAgo } from '../../services/rates'
import { RateRow } from './row'
import style from './index.module.css'

// Prices (route /rates), opened from the ticker over the calendar and from the
// menu: every price there is, by kind, with its change since yesterday. A
// switch at the top turns the ticker on or off; a tick puts one price in it.
// Read again on every visit, so it is as fresh as the source.

const GROUPS: { id: RateGroup, name: string }[] = [
    { id: 'currency', name: 'ارز' },
    { id: 'gold', name: 'سکه و طلا' },
    { id: 'crypto', name: 'رمزارز' },
]

export const RatesPage = () => {
    const base = SheetPage('قیمت ارز و طلا')

    // Over the list, so it stays in reach however far down the reader is.
    const main = Choice('checkbox', 'نمایش قیمت‌ها بالای تقویم', { checked: rates.isOn() })
    main.addClass(style.main)
    base.append(main)

    const tip = Div('قیمت‌هایی که تیک بزنید بالای تقویم نشان داده می‌شوند. تغییرها نسبت به دیروز است.')
    tip.addClass(style.tip)
    base.append(tip)

    const list = Div()
    list.addClass(style.list)
    base.append(list)

    // A fieldset, so the switch disables every tick in it at once, the
    // platform's way: a tap on a disabled row does nothing, and the keyboard
    // and screen readers are told. Set through .el because baseline's attr
    // can add an attribute but not take one away.
    const rows = Base('fieldset')
    rows.addClass(style.rows)
    list.append(rows)
    const sync = () => { (rows.el as HTMLFieldSetElement).disabled = !rates.isOn() }
    sync()

    main.on('pick', (value: boolean) => {
        rates.turn(value)
        sync()
    })

    // Where the prices come from, at the foot of the list as the country page
    // names its sources; EZRate's free plan asks for it beside the prices.
    // Outside the fieldset, so it does not fade with the ticks. _blank plus
    // rel=noopener: on native this hands the address to the system browser.
    const source = Div()
    source.addClass(style.source)
    const link = A('https://ezrate.me', 'EZRate', '_blank')
    link.addClass(style.sourceLink)
    link.el.rel = 'noopener'
    link.attr('dir', 'ltr')
    source.append(Span('منبع: '), link)
    list.append(source)

    const render = ({ rates: all, updated }: IRates) => {
        rows.empty()
        source.style({ display: all.length ? '' : 'none' })
        // Nothing before the first prices arrive: no headings over empty groups.
        if (!all.length) return
        for (const g of GROUPS) {
            const heading = Div(g.name)
            heading.addClass(style.group)
            // On the first heading only: the time is the whole list's.
            if (g === GROUPS[0]) {
                const time = Span(`به‌روزرسانی ${formatAgo(updated)}`)
                time.addClass(style.updated)
                heading.append(time)
            }
            rows.append(heading, ...all.filter(r => r.group === g.id).map(RateRow))
        }
    }

    // The prices saved last time at once, then the fresh ones when they come.
    base.on('enter', () => {
        render(rates.saved())
        rates.load().then(render)
    })

    return base
}
